module.exports = __webpack_public_path__ + "static/media/IMG_8241.5beed948.JPG";